const cards = [
  {
    tag: '口碑推荐',
    title: '这5部高分国产剧你追了几部？',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20scene%20with%20traditional%20costumes%2C%20warm%20lantern%20lighting%20in%20ancient%20courtyard%2C%20elegant%20composition%2C%20cinematic%20photography%20style%2C%20rich%20amber%20and%20gold%20tones%2C%20soft%20misty%20atmosphere%2C%20historical%20aesthetic%2C%20dramatic%20shadows&width=800&height=500&seq=cards-01&orientation=landscape',
  },
  {
    tag: '新片速递',
    title: '暑期档最值得期待的5部院线大片',
    img: 'https://readdy.ai/api/search-image?query=Modern%20cinema%20interior%20with%20warm%20ambient%20lighting%2C%20empty%20theater%20seats%20with%20glowing%20screen%2C%20cinematic%20atmosphere%2C%20soft%20dramatic%20shadows%2C%20premium%20movie%20experience%20aesthetic%2C%20rich%20coral%20and%20gold%20tones%2C%20professional%20photography&width=800&height=500&seq=cards-02&orientation=landscape',
  },
  {
    tag: '追剧指南',
    title: '零缓冲高清追剧的正确打开方式',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20home%20entertainment%20setup%20with%20large%20screen%20displaying%20vibrant%20content%2C%20warm%20ambient%20room%20lighting%2C%20comfortable%20modern%20living%20room%2C%20cinematic%20viewing%20experience%2C%20soft%20evening%20atmosphere%2C%20rich%20warm%20tones%2C%20premium%20lifestyle%20photography&width=800&height=500&seq=cards-03&orientation=landscape',
  },
  {
    tag: '经典重温',
    title: '那些年我们追过的经典港片回忆杀',
    img: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20city%20night%20scene%20with%20neon%20signs%2C%20nostalgic%20cinematic%20atmosphere%2C%20wet%20street%20reflections%2C%20warm%20glowing%20lights%2C%20film%20noir%20aesthetic%2C%20retro%20urban%20mood%2C%20dramatic%20shadows%2C%20rich%20contrast%20tones%2C%20professional%20street%20photography&width=800&height=500&seq=cards-04&orientation=landscape',
  },
  {
    tag: '观影技巧',
    title: '手机追剧如何调出最佳画质效果',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20cinematic%20content%20with%20warm%20screen%20glow%2C%20minimalist%20desk%20setup%2C%20soft%20natural%20lighting%2C%20modern%20mobile%20entertainment%20aesthetic%2C%20clean%20composition%2C%20rich%20amber%20tones%2C%20premium%20product%20photography%2C%20cozy%20atmosphere&width=800&height=500&seq=cards-05&orientation=landscape',
  },
  {
    tag: '行业观察',
    title: '2026年国剧市场趋势与好剧前瞻',
    img: 'https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20professional%20camera%20equipment%2C%20warm%20studio%20lighting%2C%20creative%20workspace%20atmosphere%2C%20cinematic%20industry%20aesthetic%2C%20soft%20dramatic%20shadows%2C%20rich%20golden%20tones%2C%20behind%20the%20scenes%20documentary%20style%2C%20professional%20photography&width=800&height=500&seq=cards-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">精选推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">影视资讯与追剧攻略精选内容</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#cards"
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              <div className="relative aspect-video overflow-hidden">
                <img src={card.img} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">{card.tag}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-bold text-foreground-900 leading-snug">{card.title}</h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}